import { render } from "./WorkshiftsCalendar.vue?vue&type=template&id=29e7d2c8"
import script from "./WorkshiftsCalendar.vue?vue&type=script&lang=js"
export * from "./WorkshiftsCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__